import api from './client';

export const reportsApi = {
  trialBalance:            (params?: any) => api.get('/reports/trial-balance', { params }),
  profitLoss:              (params?: any) => api.get('/reports/profit-loss', { params }),
  arAging:                 (params?: any) => api.get('/reports/ar-aging', { params }),
  apAging:                 (params?: any) => api.get('/reports/ap-aging', { params }),
  accountActivity:         (params?: any) => api.get('/reports/account-activity', { params }),
  inventoryActivity:       (params?: any) => api.get('/reports/inventory-activity', { params }),
  customerBalanceSummary:  (params?: any) => api.get('/reports/customer-balance-summary', { params }),
  customerBalanceDetail:   (params?: any) => api.get('/reports/customer-balance-detail', { params }),
  supplierBalanceSummary:  (params?: any) => api.get('/reports/supplier-balance-summary', { params }),
  supplierBalanceDetail:   (params?: any) => api.get('/reports/supplier-balance-detail', { params }),
  inventoryValuation:      (params?: any) => api.get('/reports/inventory-valuation', { params }),
  inventoryByLocation:     (params?: any) => api.get('/reports/inventory-by-location', { params }),
  balanceSheet:            (params?: any) => api.get('/reports/balance-sheet', { params }),
};

